var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9991 14.9596C17.9773 13.5864 17.8579 11.6757 16.6264 10.4441C15.3059 9.1237 12.9736 9.12319 11.655 10.4441C10.2803 11.8176 10.281 14.0427 11.655 15.4155C12.8867 16.6481 14.7979 16.7657 16.1705 15.7882L19.1715 18.7193L20.0001 17.8907L16.9991 14.9596Z",
    fill: "#572148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 0.343506V4.72675H14.9692L10.625 0.343506Z",
    fill: "#572148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.14 17.6178C12.888 17.6178 11.711 17.1297 10.8258 16.2433C8.9932 14.413 8.99277 11.4467 10.827 9.61488C11.8721 8.56762 13.5287 7.99875 15.3125 8.4423V5.89844H9.45312V0H0V20H15.3125V17.4518C14.9323 17.5498 14.543 17.6178 14.14 17.6178ZM2.34375 7.07031H10.625V8.24219H2.34375V7.07031ZM8.28125 15.2734H2.34375V14.1016H8.28125V15.2734ZM8.28125 12.9297H2.34375V11.7578H8.28125V12.9297ZM8.28125 10.5859H2.34375V9.41406H8.28125V10.5859Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.8073fe3ed7db7995e095d21f33b328cf.svg";
export { ForwardRef as ReactComponent };